<div class="one-column-container">

    <mat-form-field appearance="outline">
        <mat-label>Interval</mat-label>
        <span matTextPrefix>Every &nbsp;</span>
        <span matTextSuffix>&nbsp;{{ getIntervalSuffix() }}</span>
        <input matInput type="number" [formControl]="interval" placeholder="Every X months" />
        <mat-error *ngIf="intervalHasError()">{{intervalErrorMessage()}}</mat-error>
    </mat-form-field>

    <mat-slide-toggle [formControl]="dependency" color="primary">
        Wait for previous execution to complete?
    </mat-slide-toggle>

    <small class="text-muted">Months to run</small>
    <mat-chip-listbox [multiple]="true" [formControl]="monthlyOptionsSelectedMonth">
        <mat-chip-option  *ngFor="let month of months" [value]="month">
            {{ month | slice:0:3 | titlecase }}
        </mat-chip-option>
    </mat-chip-listbox>            


    <mat-form-field appearance="outline">
        <mat-label>Continuation Mode</mat-label>
        <mat-select [formControl]="continuationMode">
            <mat-option *ngFor="let continuationMode of continuationModes" [value]="continuationMode">{{ continuationMode | titlecase }}</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Execute on (day of the month)</mat-label>
        <mat-select [formControl]="monthlyOptionDayMode">
            <mat-option *ngFor="let mode of modes" [value]="mode">{{ modesDisplayMap[mode] }}</mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Specific Days -->
    <mat-form-field appearance="outline"  *ngIf="isMonthlyOnSpecificDays()">
        <mat-label>Select day number</mat-label>
        <mat-select [formControl]="monthlyOptionsSelectedDaysOfMonth">
            <mat-option *ngFor="let day of daysOfMonth" [value]="day">{{day}}</mat-option>
        </mat-select>         
    </mat-form-field>

    <div *ngIf="isMonthlyOnSelectedDayOfWeek()" >
        <small class="text-muted">Select Specific Weekday</small>
        <mat-chip-listbox [formControl]="montlyOptionSelectedDayOfTheWeek">
            <mat-chip-option *ngFor="let day of weekdays" [value]="day">
            {{ day | slice:0:3 | titlecase }}
            </mat-chip-option>
        </mat-chip-listbox>           
    </div>        

</div>
